export const GlobalRouteNames = {
    platform: 'platform',
    resources: 'resources',
    contact: 'contact'
}

export const ManagerRouteNames = {
    // work order
    workOrder: 'manager-workorder',
    workOrderEdit: 'manager-workorder-edit',
    workOrderView: 'manager-workorder-view',

    // quote
    quoteView: 'manager-quote-view',
    quoteEdit: 'manager-quote-edit',
    quote: "manager-quotes",

    // dashboard
    dashboard: 'manager-dashboard',

    // strata plan
    strataPlan: 'strata-plan',
    strataPlanView: 'manager-strataplan-view',
    strataPLanEdit: 'strata-plan-edit',

    // contact
    contactContractors: 'manager-contacts-contractors',
    contactContractorsView: 'manager-contacts-contractors-view',
    contactBuildingManagers: 'manager-contacts-building-managers',


    // todo
    contractor: 'register-contractor',
    resetPassword: 'reset-password',
    forgotPassword: 'forgot-password',
    accountUnderReview: 'account-under-review',
    verifyPhone: 'verify-phone',

    // user settings
    addMembers: 'manager-add-members',
    businessDetails: 'manager-business-details',
    teamMembers: 'manager-team-members'

}

// TODO
// find optimal way
export const ManagerMainRoutes = {
    [ManagerRouteNames.dashboard]: [ManagerRouteNames.dashboard],
    [ManagerRouteNames.workOrder]: [ManagerRouteNames.workOrder, ManagerRouteNames.workOrderEdit, ManagerRouteNames.workOrderView],
    [ManagerRouteNames.strataPlan]: [ManagerRouteNames.strataPlan, ManagerRouteNames.strataPlanView, ManagerRouteNames.strataPLanEdit],
    [ManagerRouteNames.contactContractors]: [ManagerRouteNames.contactContractors, ManagerRouteNames.contactContractorsView, ManagerRouteNames.contactBuildingManagers],
    [ManagerRouteNames.quote]: [ManagerRouteNames.quote, ManagerRouteNames.quoteEdit, ManagerRouteNames.quoteView],
}


export const ContractorRouteNames = {
    // work order
    workOrder: 'contractor-workorder',
    workOrderView: 'contractor-workorder-view',

    // quote
    quoteView: 'contractor-quote-view',
    quote: "contractor-quote",

    // dashboard
    dashboard: 'contractor-dashboard',

    // compliance
    compliance: 'contractor-compliance',
    complianceSubPage: 'contractor-compliance-sub-page',

    // contact
    contacts: 'my-contacts',
}

export const ContractorMainRoutes = {
    [ContractorRouteNames.dashboard]: [ContractorRouteNames.dashboard],
    [ContractorRouteNames.workOrder]: [ContractorRouteNames.workOrder, ContractorRouteNames.workOrderView],
    [ContractorRouteNames.contacts]: [ContractorRouteNames.contacts],
    [ContractorRouteNames.quote]: [ContractorRouteNames.quote, ContractorRouteNames.quoteView],
    [ContractorRouteNames.compliance]: [ContractorRouteNames.compliance, ContractorRouteNames.complianceSubPage],
}
